
export default function Footer() {
  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold font-serif mb-4">Forever Young</h3>
            <p className="text-gray-300 leading-relaxed">
              Calgary's premier destination for beauty and wellness treatments. Experience the confidence of radiant skin and expert care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
              <li>
                <a href="tel:4034548778" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Book Appointment
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-2 text-gray-300">
              <p>
                <a href="tel:4034548778" className="hover:text-white transition-colors cursor-pointer">
                  (403) 454-8778
                </a>
              </p>
              <p>Calgary, Alberta</p>
              <div className="mt-4">
                <p className="font-medium text-white mb-1">Hours:</p>
                <p className="text-sm">Mon-Fri: 10am-7pm</p>
                <p className="text-sm">Sat: 10am-5pm</p>
                <p className="text-sm">Sun: Closed</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-white/80 text-sm">
            © 2025 Forever Young Laser Clinic & Spa. All rights reserved.
          </p>
          <p className="text-white text-xl font-extrabold mt-4 bg-gradient-to-r from-pink-200 to-white bg-clip-text text-transparent">
            Website designed, built, maintained and hosted by{' '}
            <a 
              href="https://pockitt.info/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-white hover:text-pink-200 transition-all duration-300 cursor-pointer font-black underline decoration-2 underline-offset-4 hover:decoration-pink-200 text-2xl"
            >
              Pockitt
            </a>
            .
          </p>
        </div>
      </div>
    </footer>
  );
}
